SNI.Application.addModule('load-more', (context) => {
  // This is a temporary module for load-more until load-more is refactored.
  return {
    behaviors: ['load-more']
  };
});
